<template>
  <div class="container mx-auto">
    <div class="mb-6">
      <router-link to="/externos" class="inline-flex text-gray-700 hover:text-gray-900 border px-4 py-1 rounded text-xs border-gray-600 hover:bg-gray-300">Regresar a lista de externos</router-link>
    </div>
    <h4 class="font-semibold uppercase mb-6">Externo Nuevo</h4>
    <div class="grid grid-cols-1 gap-6 mb-10">
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="createEmpleado">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Número de Externo</label>
                  <input v-model="numeroEmpleado" readonly class="bg-gray-300 mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
              </div>
              <div class="grid grid-cols-10 gap-6 mb-6">
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Primer Nombre</label>
                  <input v-model="empleadoForm.primer_nombre" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Segundo Nombre</label>
                  <input v-model="empleadoForm.segundo_nombre" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Apellido Paterno</label>
                  <input v-model="empleadoForm.apellido_paterno" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Apellido Materno</label>
                  <input v-model="empleadoForm.apellido_materno" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-6">
                  <label class="block text-sm leading-5 text-gray-700 mb-1">CURP</label>
                  <div class="flex items-end gap-1">
                    <div class="text-center">
                      <input ref="curp0" v-model="curpSeg[0]" maxlength="4" placeholder="AAAA" @input="onCurpInput(0, 4, 'alpha')" class="curp-seg w-14 text-center uppercase" :class="segClass(curpSeg[0], 4, 'alpha')">
                      <div class="text-xs text-gray-400 mt-0.5">Letras</div>
                    </div>
                    <span class="text-gray-300 font-bold pb-5">-</span>
                    <div class="text-center">
                      <input ref="curp1" v-model="curpSeg[1]" maxlength="6" placeholder="AAMMDD" @input="onCurpInput(1, 6, 'num')" class="curp-seg w-16 text-center" :class="segClass(curpSeg[1], 6, 'num')">
                      <div class="text-xs text-gray-400 mt-0.5">Fecha</div>
                    </div>
                    <span class="text-gray-300 font-bold pb-5">-</span>
                    <div class="text-center">
                      <input ref="curp2" v-model="curpSeg[2]" maxlength="1" placeholder="H" @input="onCurpInput(2, 1, 'hm')" class="curp-seg w-8 text-center uppercase" :class="segClass(curpSeg[2], 1, 'hm')">
                      <div class="text-xs text-gray-400 mt-0.5">Sexo</div>
                    </div>
                    <span class="text-gray-300 font-bold pb-5">-</span>
                    <div class="text-center">
                      <input ref="curp3" v-model="curpSeg[3]" maxlength="2" placeholder="NL" @input="onCurpInput(3, 2, 'alpha')" class="curp-seg w-10 text-center uppercase" :class="segClass(curpSeg[3], 2, 'alpha')">
                      <div class="text-xs text-gray-400 mt-0.5">Edo</div>
                    </div>
                    <span class="text-gray-300 font-bold pb-5">-</span>
                    <div class="text-center">
                      <input ref="curp4" v-model="curpSeg[4]" maxlength="3" placeholder="XXX" @input="onCurpInput(4, 3, 'alpha')" class="curp-seg w-12 text-center uppercase" :class="segClass(curpSeg[4], 3, 'alpha')">
                      <div class="text-xs text-gray-400 mt-0.5">Cons.</div>
                    </div>
                    <span class="text-gray-300 font-bold pb-5">-</span>
                    <div class="text-center">
                      <input ref="curp5" v-model="curpSeg[5]" maxlength="2" placeholder="00" @input="onCurpInput(5, 2, 'alnum')" class="curp-seg w-10 text-center uppercase" :class="segClass(curpSeg[5], 2, 'alnum')">
                      <div class="text-xs text-gray-400 mt-0.5">Homo</div>
                    </div>
                    <span class="pb-5 ml-2 text-xs font-mono" :class="curpFull.length === 18 ? 'text-green-600' : 'text-gray-400'">{{ curpFull.length }}/18</span>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">INE <span class="text-xs text-gray-400 font-normal">(IDMEX + 9 dígitos — reverso de la credencial)</span></label>
                  <div class="flex items-center mt-1">
                    <span class="inline-flex items-center px-2 py-1 bg-gray-200 border border-r-0 border-gray-400 rounded-l text-xs font-semibold text-gray-600">IDMEX</span>
                    <input v-model="empleadoForm.ine" maxlength="9" placeholder="000000000" @input="empleadoForm.ine = empleadoForm.ine.replace(/[^0-9]/g, '')" class="form-input block w-full py-1 px-3 border border-gray-400 rounded-r shadow-sm text-sm leading-6 focus:outline-none" :class="empleadoForm.ine.length === 9 ? 'border-green-500' : empleadoForm.ine.length > 0 ? 'border-yellow-400' : ''">
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Fecha Nacimiento</label>
                  <datepicker v-model="fechaNacimiento" :language="es" :format="format" required></datepicker>
                </div>
                <div class="col-span-5">
                  <label class="block text-sm leading-5 text-gray-700">Lugar Nacimiento</label>
                  <input v-model="empleadoForm.lugar_nacimiento" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Sexo</label>
                  <select v-model="empleadoForm.sexo" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option>Masculino</option>
                    <option>Femenino</option>
                  </select>
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Nacionalidad</label>
                  <select v-model="empleadoForm.nacionalidad" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option>Mexicana</option>
                    <option>Argentina</option>
                    <option>Boliviana</option>
                    <option>Brasileña</option>
                    <option>Chilena</option>
                    <option>Colombiana</option>
                    <option>Costarricense</option>
                    <option>Cubana</option>
                    <option>Dominicana</option>
                    <option>Ecuatoriana</option>
                    <option>Estadounidense</option>
                    <option>Guatemalteca</option>
                    <option>Haitiana</option>
                    <option>Hondureña</option>
                    <option>Nicaragüense</option>
                    <option>Panameña</option>
                    <option>Paraguaya</option>
                    <option>Peruana</option>
                    <option>Puertorriqueña</option>
                    <option>Salvadoreña</option>
                    <option>Uruguaya</option>
                    <option>Venezolana</option>
                    <option>Otra</option>
                  </select>
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Estado Civil</label>
                  <select v-model="empleadoForm.estado_civil" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option>Soltero</option>
                    <option>Casado</option>
                    <option>Divorciado</option>
                    <option>Viudo</option>
                    <option>Concubinato</option>
                  </select>
                </div>
                <hr class="col-span-12"/>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Fecha Ingreso</label>
                  <datepicker v-model="fechaIngreso" :language="es" :format="format" required></datepicker>
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Sucursal</label>
                  <select v-model="empleadoForm.sucursalId" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option v-for="(item, key) in sucursales" :value="item.id" :key="key">{{item.nombre}}</option>
                  </select>
                </div>
                <hr class="col-span-12"/>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Correo Electrónico</label>
                  <input type="email" v-model="empleadoForm.correo_electronico" required placeholder="ejemplo@correo.com" @input="empleadoForm.correo_electronico = empleadoForm.correo_electronico.toLowerCase()" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none" :class="empleadoForm.correo_electronico.includes('@') && empleadoForm.correo_electronico.includes('.') ? 'border-green-500' : empleadoForm.correo_electronico.length > 0 ? 'border-yellow-400' : ''" style="text-transform: lowercase">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Teléfono Celular</label>
                  <input v-model="empleadoForm.telefono_celular" maxlength="10" pattern="[0-9]{10}" required @input="empleadoForm.telefono_celular = empleadoForm.telefono_celular.replace(/[^0-9]/g, '')" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none" :class="empleadoForm.telefono_celular.length === 10 ? 'border-green-500' : empleadoForm.telefono_celular.length > 0 ? 'border-yellow-400' : ''">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Teléfono Casa</label>
                  <input type="tel" size="10" maxlength="10" minlength="10" v-model="empleadoForm.telefono_casa" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <hr class="col-span-12"/>
              </div>
              <div class="grid grid-cols-12 gap-6 mb-6">
                <div class="col-span-6">
                  <label class="block text-sm leading-5 text-gray-700">Domicilio Calle</label>
                  <input v-model="empleadoForm.domicilio_calle" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-2">
                  <label class="block text-sm leading-5 text-gray-700">No Exterior</label>
                  <input v-model="empleadoForm.domicilio_noexterior" type="number" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-2">
                  <label class="block text-sm leading-5 text-gray-700">No Interior</label>
                  <input v-model="empleadoForm.domicilio_nointerior" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-4">
                  <label class="block text-sm leading-5 text-gray-700">Colonia</label>
                  <input v-model="empleadoForm.domicilio_colonia" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Municipio</label>
                  <input v-model="empleadoForm.domicilio_municipio" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Entidad Federativa</label>
                  <select v-model="empleadoForm.domicilio_entidad_federativa" class="mt-1 block form-select w-full py-2 px-3 border border-gray-400 bg-white rounded shadow-sm focus:outline-none text-xs">
                    <option>Nuevo León</option>
                  </select>
                </div>
                <div class="col-span-2">
                  <label class="block text-sm leading-5 text-gray-700">Codigo Postal</label>
                  <input size="5" maxlength="5" minlength="5" v-model="empleadoForm.domicilio_codigo_postal" required class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <hr class="col-span-12"/>
              </div>
              <div class="grid grid-cols-12 gap-6">
                <div class="col-span-6">
                  <label class="block text-sm leading-5 text-gray-700">Referencia 1 Nombre</label>
                  <input v-model="empleadoForm.referencia_personal_uno_nombre" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Referencia 1 Teléfono</label>
                  <input type="tel" size="10" maxlength="10" minlength="10" v-model="empleadoForm.referencia_personal_uno_telefono" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-6">
                  <label class="block text-sm leading-5 text-gray-700">Referencia 2 Nombre</label>
                  <input v-model="empleadoForm.referencia_personal_dos_nombre" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
                <div class="col-span-3">
                  <label class="block text-sm leading-5 text-gray-700">Referencia 2 Teléfono</label>
                  <input type="tel" size="10" maxlength="10" minlength="10" v-model="empleadoForm.referencia_personal_dos_telefono" class="mt-1 form-input block w-full py-1 px-3 border border-gray-400 rounded shadow-sm text-sm leading-6 focus:outline-none">
                </div>
              </div>
            </div>
            <div class="py-4 bg-gray-50 px-6">
              <button class="py-1 px-4 border border-transparent text-sm leading-5 rounded text-white bg-green-500 hover:bg-green-600 focus:outline-none">
                Registrar Externo
              </button>
              <span v-show="errorCaptura" class="text-red-600 text-sm ml-6">Error al registrar externo, verificar datos.</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/src/locale'
import authClient from '@/utils/auth'
import moment from 'moment-timezone'
export default {
  name: 'NuevoEmpleadoExterno',
  components: {
    Datepicker
  },
  data () {
    return {
      es: es,
      format: 'd MMMM yyyy',
      numeroEmpleado: 0,
      sucursales: [],
      empresaSeleccionada: this.$store.getters.empresaSeleccionada,
      errorCaptura: false,
      fechaNacimiento: '',
      fechaIngreso: '',
      curpSeg: ['', '', '', '', '', ''],
      empleadoForm: {
        numero_empleado: 0,
        primer_nombre: '',
        segundo_nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        curp: '',
        ine: '',
        fecha_nacimiento: '',
        lugar_nacimiento: '',
        nacionalidad: 'Mexicana',
        estado_civil: 'Soltero',
        sexo: 'Masculino',
        fecha_ingreso: '',
        correo_electronico: '',
        telefono_celular: '',
        telefono_casa: '',
        domicilio_calle: '',
        domicilio_noexterior: '',
        domicilio_nointerior: '',
        domicilio_colonia: '',
        domicilio_municipio: '',
        domicilio_entidad_federativa: 'Nuevo León',
        domicilio_codigo_postal: '',
        referencia_personal_uno_nombre: '',
        referencia_personal_uno_telefono: '',
        referencia_personal_dos_nombre: '',
        referencia_personal_dos_telefono: '',
        empresaId: this.$store.getters.empresaSeleccionada,
        sucursalId: 0
      }
    }
  },
  computed: {
    curpFull () {
      return this.curpSeg.join('').toUpperCase()
    }
  },
  methods: {
    onCurpInput (idx, max, type) {
      let v = this.curpSeg[idx]
      if (type === 'alpha') v = v.replace(/[^a-zA-ZñÑ]/g, '')
      else if (type === 'num') v = v.replace(/[^0-9]/g, '')
      else if (type === 'hm') v = v.replace(/[^hmHM]/g, '')
      else if (type === 'alnum') v = v.replace(/[^a-zA-Z0-9]/g, '')
      v = v.toUpperCase().slice(0, max)
      this.$set(this.curpSeg, idx, v)
      this.empleadoForm.curp = this.curpFull
      if (v.length >= max && idx < 5) {
        this.$nextTick(() => this.$refs['curp' + (idx + 1)].focus())
      }
    },
    segClass (val, expected, type) {
      if (!val) return 'border-gray-400'
      let valid = val.length === expected
      if (type === 'alpha') valid = valid && /^[A-ZÑ]+$/i.test(val)
      else if (type === 'num') valid = valid && /^[0-9]+$/.test(val)
      else if (type === 'hm') valid = valid && /^[HM]$/i.test(val)
      else if (type === 'alnum') valid = valid && /^[A-Z0-9]+$/i.test(val)
      if (valid) return 'border-green-500 bg-green-50'
      if (val.length === expected) return 'border-red-400 bg-red-50'
      return 'border-yellow-400 bg-yellow-50'
    },
    obtenerEmpleado () {
      this.$http.post('/api/empleado-externo/ultimo-empleado-empresa', { empresa: this.empresaSeleccionada }, {
        headers: { Authorization: authClient.getAuthToken() }
      })
        .then(({ data }) => {
          this.numeroEmpleado = parseInt(data) + 1
          this.empleadoForm.numero_empleado = parseInt(data) + 1
        })
    },
    obtenerSucursales () {
      this.$http.post('/api/sucursal/sucursales-empresa', { empresa: this.empresaSeleccionada }, {
        headers: { Authorization: authClient.getAuthToken() }
      })
        .then(({ data }) => {
          this.sucursales = data
          if (data.length > 0) {
            this.empleadoForm.sucursalId = data[0].id
          }
        })
    },
    createEmpleado () {
      var payload = Object.assign({}, this.empleadoForm)
      if (payload.ine) payload.ine = 'IDMEX' + payload.ine
      this.$http.post('/api/empleado-externo/alta', payload, {
        headers: { Authorization: authClient.getAuthToken() }
      })
        .then(() => this.$router.push('/externos'))
        .catch(() => {
          this.errorCaptura = true
          setTimeout(() => (this.errorCaptura = false), 5000)
        })
    }
  },
  mounted () {
    this.obtenerEmpleado()
    this.obtenerSucursales()
  },
  watch: {
    fechaNacimiento (newVal, oldVal) {
      this.empleadoForm.fecha_nacimiento = moment(newVal).format('YYYY-MM-DD')
    },
    fechaIngreso (newVal, oldVal) {
      this.empleadoForm.fecha_ingreso = moment(newVal).format('YYYY-MM-DD')
    }
  }
}
</script>
<style scoped>
.curp-seg {
  padding: 4px 2px;
  border: 1.5px solid;
  border-radius: 4px;
  font-size: 13px;
  font-family: monospace;
  font-weight: 600;
  outline: none;
  transition: border-color 0.15s, background-color 0.15s;
}
.curp-seg:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59,130,246,0.2);
}
</style>
